import React from 'react';
import { Card, CloseButton } from 'react-bootstrap';
import { useSession } from 'components/sessions/context/SessionContext';
import '../css/SessionList.css';

const SessionList = () => {
  const { sessions, deleteSession, convertHoursToTime, calculatePLPerHour } = useSession();

  const handleDelete = (sessionId) => {
    deleteSession(sessionId);
  };

  return (
    <>
      {sessions.map((session) => {
        const plPerHour = calculatePLPerHour(session.profitLoss, session.sessionHours);
        return (
          <Card className="session-item" key={session.id}>
            <Card.Header className="card-header">
              <div className="date">{session.date}</div>
              <CloseButton className="close-button" onClick={() => handleDelete(session.id)} />
            </Card.Header>
            <Card.Body>
              <div>
                Hours: {convertHoursToTime(session.sessionHours)} | P/L: ${session.profitLoss}
                {plPerHour && <span className="pl-per-hour"> (${plPerHour}/h)</span>}
              </div>
              <div>Game: {session.SB} / {session.BB}</div>
            </Card.Body>
          </Card>
        );
      })}
    </>
  );
};

export default SessionList;
